export const TCF_VERSION = 2
export const SKIP_CMP_COOKIE_NAME = 'skipCmp'
export const SKIP_CMP_FULL_CONSENT_VALUE = 'full-consent'
export const DISABLE_CONSENTS_QUERY_PARAM = 'disable-cmp'
export const DIDOMI_TOKEN_KEY = 'didomi_token'
export const CONSENT_COOKIE_NAME = 'euconsent-v2'

export const DIDOMI_IDS = {
  PUBLIC_API_KEY: 'c375614b-7a6b-4f34-aa74-4919ca34a081',
  NOTICE_ID: {
    motosnet: 'EaMa7PLn',
    cochesnet: 'iygQFwN8'
  }
}
